import { render, staticRenderFns } from "./RestoreAccountModal.vue?vue&type=template&id=5d44e78e&"
import script from "./RestoreAccountModal.vue?vue&type=script&lang=ts&"
export * from "./RestoreAccountModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports